import { render } from "./ProductRequirements.vue?vue&type=template&id=60e79bac"
import script from "./ProductRequirements.vue?vue&type=script&lang=js"
export * from "./ProductRequirements.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__